export default __webpack_public_path__ + "static/media/BannerSmall.c887f416.png";